// // import React, { useEffect, useState } from "react";
// // import { useNavigate } from "react-router-dom";
// // import api from "../../utils/api";
// // import RoomCard from "../../components/listings/RoomCard";
// // import Button from "../../components/common/Button";
// // import { ROOM_TYPE_OPTIONS } from "../../constants/listingOptions";

// // export default function HomePage() {
// //   const navigate = useNavigate();

// //   const [rooms, setRooms] = useState([]);
// //   const [loading, setLoading] = useState(false);
// //   const [filters, setFilters] = useState({
// //     location: "",
// //     budget: "",
// //     roomType: "",
// //   });

// //   function handleChange(e) {
// //     const { name, value } = e.target;

// //     setFilters((prev) => ({
// //       ...prev,
// //       [name]: value,
// //     }));
// //   }

// //   const loadRooms = async () => {
// //     setLoading(true);

// //     try {
// //       const res = await api.get("/listings/search", {
// //         params: {
// //           availability: true,
// //           location: filters.location,
// //           budget: filters.budget,
// //           roomType: filters.roomType,
// //         },
// //       });

// //       console.log(res.data);
// //       setRooms(res.data);
// //     } catch (err) {
// //       console.error(err);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   useEffect(() => {
// //     loadRooms();
// //   }, []);

// //   return (
// //     <div className="max-w-7xl mx-auto px-6 py-2">
// //       {/* Hero Section */}
// //       <h1 className="text-4xl font-bold text-center">
// //         Find Your Ideal Room Quickly
// //       </h1>

// //       <p className="text-gray-500 text-center">
// //         The only platform dedicated exclusively to room rentals.
// //       </p>

// //       {/* Search Bar */}
// //       <div className="bg-white p-1 rounded-2xl shadow-md mt-3 flex items-center gap-4">
// //         <input
// //           name="location"
// //           value={filters.location}
// //           onChange={handleChange}
// //           placeholder="Location"
// //           className="flex-1 border rounded-xl p-3"
// //         />

// //         <input
// //           type="number"
// //           name="budget"
// //           value={filters.budget}
// //           onChange={handleChange}
// //           placeholder="Budget (NPR)"
// //           className="flex-1 border rounded-xl p-3"
// //         />

// //         <select
// //           name="roomType"
// //           value={filters.roomType}
// //           onChange={handleChange}
// //           className="flex-1 border rounded-xl p-3"
// //         >
// //           <option value="">Room Type</option>
// //           {ROOM_TYPE_OPTIONS.map((type) => (
// //             <option key={type} value={type}>
// //               {type}
// //             </option>
// //           ))}
// //         </select>

// //         <Button
// //           className="w-40"
// //           variant="primary"
// //           onClick={loadRooms}
// //         >
// //           Search Rooms
// //         </Button>

// //       </div>

// //       {/* Featured Rooms */}
// //       <h2 className="text-2xl font-semibold mt-6">Featured Rooms</h2>

// //       <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-6">
// //         {loading && <p className="text-gray-500">Loading available rooms...</p>}

// //         {!loading && rooms.length === 0 && (
// //           <p className="text-gray-500">No available rooms at the moment.</p>
// //         )}

// //         {/* Render real database rooms */}
// //         {!loading &&
// //           rooms.map((room) => (
// //             <RoomCard
// //               key={room.id}
// //               room={{
// //                 id: room.id,
// //                 ownerId: room.ownerId,
// //                 image: room.images?.[0] || "/images/sample.jpg",
// //                 title: room.title,
// //                 location: room.location,
// //                 roomType:room.roomType,
// //                 price: room.rentAmount,
// //               }}
// //             />
// //           ))}
// //       </div>
// //     </div>
// //   );
// // }

// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import api from "../../utils/api";
// import RoomCard from "../../components/listings/RoomCard";
// import Button from "../../components/common/Button";
// import { ROOM_TYPE_OPTIONS } from "../../constants/listingOptions";

// export default function HomePage() {
//   const navigate = useNavigate();

//   const [rooms, setRooms] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [filters, setFilters] = useState({
//     location: "",
//     budget: "",
//     roomType: "",
//   });

//   /*
//   |--------------------------------------------------------------------------
//   | Filter Change
//   |--------------------------------------------------------------------------
//   */

//   function handleChange(e) {
//     const { name, value } = e.target;

//     setFilters((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   }

//   /*
//   |--------------------------------------------------------------------------
//   | Load Rooms
//   |--------------------------------------------------------------------------
//   */

//   const loadRooms = async () => {
//     setLoading(true);

//     try {
//       const params = {
//         availability: true,
//       };

//       // Only send filters if they have values
//       if (filters.location.trim()) {
//         params.location = filters.location.trim();
//       }

//       if (filters.budget) {
//         params.budget = filters.budget;
//       }

//       if (filters.roomType) {
//         params.roomType = filters.roomType;
//       }

//       const res = await api.get("/listings/search", {
//         params,
//       });

//       /*
//        * Depending on your backend response:
//        *
//        * res.data
//        * OR
//        * res.data.data
//        */

//       const data = Array.isArray(res.data) ? res.data : res.data?.data || [];

//       setRooms(data);
//     } catch (err) {
//       console.error("Failed to load rooms:", err);
//       setRooms([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   /*
//   |--------------------------------------------------------------------------
//   | Initial Load
//   |--------------------------------------------------------------------------
//   */

//   useEffect(() => {
//     loadRooms();
//   }, []);

//   /*
//   |--------------------------------------------------------------------------
//   | Search
//   |--------------------------------------------------------------------------
//   */

//   function handleSearch(e) {
//     e?.preventDefault();

//     loadRooms();
//   }

//   /*
//   |--------------------------------------------------------------------------
//   | Split Rooms
//   |--------------------------------------------------------------------------
//   */

//   const featuredRooms = rooms.slice(0, 3);

//   const moreRooms = rooms.slice(3, 8);

//   /*
//   |--------------------------------------------------------------------------
//   | Room Adapter
//   |--------------------------------------------------------------------------
//   */

//   function formatRoom(room) {
//     return {
//       id: room.id,
//       ownerId: room.ownerId,
//       image: room.images?.[0] || "/images/sample.jpg",
//       title: room.title,
//       location: room.location,
//       roomType: room.roomType,
//       price: room.rentAmount,
//     };
//   }

//   return (
//     <div className="bg-white min-h-screen">
//       {/* ================================================================
//           HERO / SEARCH SECTION
//       ================================================================ */}

//       <section className="max-w-7xl mx-auto px-5 sm:px-6 pt-8">
//         <div className="text-center">
//           <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
//             Find Your Ideal Room Quickly
//           </h1>

//           <p className="text-gray-500 text-sm md:text-base mt-2">
//             The only platform dedicated exclusively to room rentals.
//           </p>
//         </div>

//         {/* ============================================================
//             SEARCH BAR
//         ============================================================ */}

//         <form
//           onSubmit={handleSearch}
//           className="
//             bg-white
//             border
//             border-gray-200
//             rounded-2xl
//             shadow-sm
//             mt-6
//             p-2
//             flex
//             flex-col
//             md:flex-row
//             gap-2
//           "
//         >
//           {/* Location */}

//           <input
//             name="location"
//             value={filters.location}
//             onChange={handleChange}
//             placeholder="Location"
//             className="
//               flex-1
//               border
//               border-gray-200
//               rounded-xl
//               px-4
//               py-3
//               text-sm
//               outline-none
//               focus:ring-2
//               focus:ring-orange-400
//             "
//           />

//           {/* Budget */}

//           <input
//             type="number"
//             name="budget"
//             value={filters.budget}
//             onChange={handleChange}
//             placeholder="Budget (NPR)"
//             className="
//               flex-1
//               border
//               border-gray-200
//               rounded-xl
//               px-4
//               py-3
//               text-sm
//               outline-none
//               focus:ring-2
//               focus:ring-orange-400
//             "
//           />

//           {/* Room Type */}

//           <select
//             name="roomType"
//             value={filters.roomType}
//             onChange={handleChange}
//             className="
//               flex-1
//               border
//               border-gray-200
//               rounded-xl
//               px-4
//               py-3
//               text-sm
//               bg-white
//               outline-none
//               focus:ring-2
//               focus:ring-orange-400
//             "
//           >
//             <option value="">Room Type</option>

//             {ROOM_TYPE_OPTIONS.map((type) => (
//               <option key={type} value={type}>
//                 {type}
//               </option>
//             ))}
//           </select>

//           {/* Search */}

//           <Button type="submit" variant="primary" className="md:w-36">
//             Search Room
//           </Button>
//         </form>
//       </section>

//       {/* ================================================================
//           HERO ADVERTISEMENT
//       ================================================================ */}

//       <section className="max-w-7xl mx-auto px-5 sm:px-6 mt-6">
//         <Advertisement
//           src="/images/advertisements/homePage/hero-banner.jpg"
//           alt="RoomVetiyo Hero Advertisement"
//           size="hero"
//         />
//       </section>

//       {/* ================================================================
//           FEATURED ROOMS
//       ================================================================ */}

//       <section className="max-w-7xl mx-auto px-5 sm:px-6 mt-8">
//         <div className="flex items-center justify-between mb-4">
//           <div>
//             <h2 className="text-xl md:text-2xl font-bold text-gray-900">
//               Featured Rooms
//             </h2>

//             <p className="text-sm text-gray-500 mt-1">
//               Explore some of the latest available rooms.
//             </p>
//           </div>

//           <button
//             type="button"
//             onClick={() => navigate("/search")}
//             className="
//               text-sm
//               font-medium
//               text-gray-700
//               hover:text-orange-500
//             "
//           >
//             View All →
//           </button>
//         </div>

//         {/* Loading */}

//         {loading && (
//           <div className="py-10 text-center text-gray-500">
//             Loading available rooms...
//           </div>
//         )}

//         {/* No rooms */}

//         {!loading && featuredRooms.length === 0 && (
//           <div className="bg-gray-50 rounded-2xl p-10 text-center">
//             <p className="text-gray-500">No available rooms at the moment.</p>
//           </div>
//         )}

//         {/* Featured Rooms */}

//         {!loading && featuredRooms.length > 0 && (
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
//             {featuredRooms.map((room) => (
//               <RoomCard key={room.id} room={formatRoom(room)} />
//             ))}
//           </div>
//         )}
//       </section>

//       {/* ================================================================
//           IN-FEED ADVERTISEMENT
//       ================================================================ */}

//       <section className="max-w-7xl mx-auto px-5 sm:px-6 mt-8">
//         <Advertisement
//           src="/images/advertisements/in-feed-banner.jpg"
//           alt="RoomVetiyo In-Feed Advertisement"
//           size="infeed"
//         />
//       </section>

//       {/* ================================================================
//           MORE ROOMS
//       ================================================================ */}

//       <section className="max-w-7xl mx-auto px-5 sm:px-6 mt-8">
//         <div className="flex items-center justify-between mb-4">
//           <div>
//             <h2 className="text-xl md:text-2xl font-bold">More Rooms</h2>

//             <p className="text-sm text-gray-500 mt-1">
//               Find a room that matches your requirements.
//             </p>
//           </div>

//           <button
//             type="button"
//             onClick={() => navigate("/search")}
//             className="
//               text-sm
//               font-medium
//               text-gray-700
//               hover:text-orange-500
//             "
//           >
//             View All →
//           </button>
//         </div>

//         {!loading && moreRooms.length > 0 && (
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
//             {moreRooms.map((room) => (
//               <RoomCard key={room.id} room={formatRoom(room)} />
//             ))}

//             {/* ======================================================
//                   SPONSORED CARD
//               ====================================================== */}

//             <SponsoredCard />
//           </div>
//         )}
//       </section>

//       {/* ================================================================
//           FOOTER ADVERTISEMENT
//       ================================================================ */}

//       <section className="max-w-7xl mx-auto px-5 sm:px-6 mt-10">
//         <Advertisement
//           src="/images/advertisements/footer-banner.jpg"
//           alt="RoomVetiyo Footer Advertisement"
//           size="footer"
//         />
//       </section>

//       {/* ================================================================
//           ADVERTISING BENEFITS
//       ================================================================ */}

//       <section className="max-w-7xl mx-auto px-5 sm:px-6 mt-8 mb-10">
//         <div
//           className="
//           border
//           border-pink-200
//           rounded-2xl
//           overflow-hidden
//         "
//         >
//           {/* Header */}

//           <div
//             className="
//             bg-pink-50
//             text-center
//             py-2
//           "
//           >
//             <h3
//               className="
//               font-semibold
//               text-pink-500
//             "
//             >
//               ADVERTISING BENEFITS
//             </h3>
//           </div>

//           {/* Benefits */}

//           <div
//             className="
//             grid
//             grid-cols-1
//             sm:grid-cols-2
//             lg:grid-cols-4
//           "
//           >
//             <Benefit
//               icon="◉"
//               title="High Visibility"
//               text="Reach thousands of room seekers daily."
//             />

//             <Benefit
//               icon="◎"
//               title="Targeted Audience"
//               text="Your ads reach people actively looking for rooms."
//             />

//             <Benefit
//               icon="↗"
//               title="Brand Growth"
//               text="Build awareness and grow your business."
//             />

//             <Benefit
//               icon="₹"
//               title="Affordable Plans"
//               text="Flexible advertising options for every business size."
//             />
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }

// /*
// |--------------------------------------------------------------------------
// | Advertisement Component
// |--------------------------------------------------------------------------
// */

// function Advertisement({ src, alt, size = "hero" }) {
//   const sizes = {
//     hero: {
//       height: "h-[120px] md:h-[150px]",
//       label: "1200 × 150 px",
//     },

//     infeed: {
//       height: "h-[100px] md:h-[120px]",
//       label: "1200 × 120 px",
//     },

//     footer: {
//       height: "h-[80px] md:h-[100px]",
//       label: "1200 × 100 px",
//     },
//   };

//   const current = sizes[size];

//   return (
//     <div className="w-full">
//       <div className="relative group">
//         {/* Advertisement Label */}

//         <span
//           className="
//           absolute
//           top-2
//           right-3
//           z-10
//           text-[9px]
//           text-gray-500
//           bg-white/80
//           px-2
//           py-0.5
//           rounded
//         "
//         >
//           ADVERTISEMENT
//         </span>

//         <img
//           src={src}
//           alt={alt}
//           className={`
//             w-full
//             ${current.height}
//             object-cover
//             rounded-xl
//             border
//             border-gray-200
//             transition
//             duration-300
//             group-hover:shadow-lg
//           `}
//         />
//       </div>

//       <p
//         className="
//         text-center
//         text-[10px]
//         text-gray-400
//         mt-1
//       "
//       >
//         {current.label}
//       </p>
//     </div>
//   );
// }

// /*
// |--------------------------------------------------------------------------
// | Sponsored Card
// |--------------------------------------------------------------------------
// */

// function SponsoredCard() {
//   const navigate = useNavigate();

//   return (
//     <div
//       className="
//       bg-gradient-to-br
//       from-purple-50
//       to-purple-100
//       rounded-2xl
//       border
//       border-purple-200
//       overflow-hidden
//       relative
//       hover:shadow-lg
//       transition
//     "
//     >
//       {/* Sponsored Badge */}

//       <div
//         className="
//         absolute
//         top-3
//         left-3
//         z-10
//         bg-purple-600
//         text-white
//         text-[10px]
//         font-semibold
//         px-2
//         py-1
//         rounded-full
//       "
//       >
//         SPONSORED
//       </div>

//       {/* Advertisement Image */}

//       <img
//         src="/images/advertisements/homePage/sponsored-card.jpg"
//         alt="Sponsored Advertisement"
//         className="
//           w-full
//           h-44
//           object-cover
//         "
//       />

//       <div className="p-4">
//         <p
//           className="
//           text-purple-700
//           text-xs
//           font-semibold
//         "
//         >
//           SPECIAL OFFER
//         </p>

//         <h3
//           className="
//           text-lg
//           font-bold
//           text-gray-900
//           mt-1
//         "
//         >
//           Premium Home Furniture
//         </h3>

//         <p
//           className="
//           text-sm
//           text-gray-600
//           mt-1
//         "
//         >
//           Upgrade your living space with premium furniture.
//         </p>

//         <button
//           type="button"
//           onClick={() => {}}
//           className="
//             mt-4
//             bg-purple-600
//             hover:bg-purple-700
//             text-white
//             text-sm
//             font-medium
//             px-5
//             py-2
//             rounded-lg
//             transition
//           "
//         >
//           Learn More
//         </button>
//       </div>
//     </div>
//   );
// }

// /*
// |--------------------------------------------------------------------------
// | Advertising Benefit
// |--------------------------------------------------------------------------
// */

// function Benefit({ icon, title, text }) {
//   return (
//     <div
//       className="
//       p-5
//       flex
//       gap-4
//       border-b
//       sm:border-r
//       lg:border-b-0
//       border-gray-200
//       last:border-r-0
//     "
//     >
//       <div
//         className="
//         w-10
//         h-10
//         rounded-full
//         bg-pink-50
//         text-pink-500
//         flex
//         items-center
//         justify-center
//         text-xl
//         flex-shrink-0
//       "
//       >
//         {icon}
//       </div>

//       <div>
//         <h4
//           className="
//           font-semibold
//           text-gray-900
//         "
//         >
//           {title}
//         </h4>

//         <p
//           className="
//           text-xs
//           text-gray-500
//           mt-1
//           leading-5
//         "
//         >
//           {text}
//         </p>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import api from "../../utils/api";
import RoomCard from "../../components/listings/RoomCard";
import Button from "../../components/common/Button";

import { ROOM_TYPE_OPTIONS } from "../../constants/listingOptions";

export default function HomePage() {
  const navigate = useNavigate();

  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    location: "",
    budget: "",
    roomType: "",
  });

  /*
  |--------------------------------------------------------------------------
  | Handle Search Input
  |--------------------------------------------------------------------------
  */

  function handleChange(e) {
    const { name, value } = e.target;

    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  }

  /*
  |--------------------------------------------------------------------------
  | Load Rooms
  |--------------------------------------------------------------------------
  */

  const loadRooms = async () => {
    setLoading(true);

    try {
      const params = {
        availability: true,
      };

      /*
       * Only send location if user entered it
       */
      if (filters.location.trim()) {
        params.location = filters.location.trim();
      }

      /*
       * Only send budget if user entered it
       */
      if (filters.budget) {
        params.budget = filters.budget;
      }

      /*
       * Only send room type if selected
       */
      if (filters.roomType) {
        params.roomType = filters.roomType;
      }

      console.log("Searching rooms with:", params);

      const res = await api.get("/listings/search", {
        params,
      });

      /*
       * Supports both:
       *
       * res.data = []
       *
       * and
       *
       * res.data = {
       *   data: []
       * }
       */

      const data = Array.isArray(res.data) ? res.data : res.data?.data || [];

      setRooms(data);
    } catch (err) {
      console.error("Failed to load rooms:", err);

      setRooms([]);
    } finally {
      setLoading(false);
    }
  };

  /*
  |--------------------------------------------------------------------------
  | Initial Load
  |--------------------------------------------------------------------------
  */

  useEffect(() => {
    loadRooms();
  }, []);

  /*
  |--------------------------------------------------------------------------
  | Search Button
  |--------------------------------------------------------------------------
  */

  function handleSearch(e) {
    e.preventDefault();

    loadRooms();
  }

  /*
  |--------------------------------------------------------------------------
  | Prepare Room Object
  |--------------------------------------------------------------------------
  */

  function formatRoom(room) {
    return {
      id: room.id,

      ownerId: room.ownerId,

      image: room.images?.[0] || "/images/sample.jpg",

      title: room.title,

      location: room.location,

      roomType: room.roomType,

      price: room.rentAmount,
    };
  }

  /*
  |--------------------------------------------------------------------------
  | Room Sections
  |--------------------------------------------------------------------------
  */

  const firstRooms = rooms.slice(0, 6);

  const remainingRooms = rooms.slice(6);

  return (
    <div className="bg-white min-h-screen">
      {/* ================================================================
          HERO / SEARCH
      ================================================================ */}

      <section className="max-w-8xl mx-auto px-5 sm:px-6 pt-8">
        <div className="text-center">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
            Find Your Ideal Room Quickly
          </h1>

          <p className="text-gray-500 text-sm md:text-base mt-2">
            The only platform dedicated exclusively to room rentals.
          </p>
        </div>

        {/* ============================================================
            SEARCH BAR
        ============================================================ */}

        <form
          onSubmit={handleSearch}
          className="bg-white border border-gray-200 rounded-2xl shadow-md mt-6 p-2 flex flex-col md:flex-row gap-2"
        >
          {/* Location */}

          <input
            type="text"
            name="location"
            value={filters.location}
            onChange={handleChange}
            placeholder="Location"
            className="flex-1 border border-gray-200 rounded-xl px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-orange-400"
          />

          {/* Budget */}

          <input
            type="number"
            name="budget"
            value={filters.budget}
            onChange={handleChange}
            placeholder="Budget (NPR)"
            className="flex-1 border border-gray-200 rounded-xl px-4 py-3 text-sm outline-none focus:ring-2 focus:ring-orange-400"
          />

          {/* Room Type */}

          <select
            name="roomType"
            value={filters.roomType}
            onChange={handleChange}
            className="flex-1 border border-gray-200 rounded-xl px-4 py-3 text-sm bg-white outline-none focus:ring-2 focus:ring-orange-400"
          >
            <option value="">Room Type</option>

            {ROOM_TYPE_OPTIONS.map((type) => (
              <option key={type} value={type}>
                {type}
              </option>
            ))}
          </select>

          {/* Search Button */}

          <Button type="submit" variant="primary" className="md:w-40">
            Search Room
          </Button>
        </form>
      </section>

      {/* ================================================================
          HERO ADVERTISEMENT
          1200 x 250
      ================================================================ */}

      <section className="max-w-8xl mx-auto px-5 sm:px-6 mt-6">
        <Advertisement
          src="/images/advertisements/homePage/hero-banner.jpeg"
          alt="RoomVetiyo Hero Advertisement"
          size="hero"
          href="#"
        />
      </section>

      {/* ================================================================
          MAIN ROOM + ADVERTISEMENT AREA
          
          4 PARTS HORIZONTALLY
          
          3 PARTS = ROOMS
          1 PART  = ADVERTISEMENT
      ================================================================ */}

      <section className="max-w-8xl mx-auto px-5 sm:px-6 mt-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {/* ==========================================================
              LEFT 3 PARTS
              ROOM DATA
          ========================================================== */}

          <div className="lg:col-span-3">
            {/* ========================================================
                FEATURED ROOMS HEADER
            ======================================================== */}

            <div className="flex items-center justify-between mb-5">
              <div>
                <h2 className="text-xl md:text-2xl font-bold text-gray-900">
                  Featured Rooms
                </h2>

                <p className="text-sm text-gray-500 mt-1">
                  Explore some of the latest available rooms.
                </p>
              </div>

              <button
                type="button"
                onClick={() => navigate("/search")}
                className="text-sm font-medium text-gray-700 hover:text-orange-500 transition"
              >
                View All →
              </button>
            </div>

            {/* ========================================================
                LOADING
            ======================================================== */}

            {loading && (
              <div className="bg-gray-50 rounded-2xl p-10 text-center">
                <p className="text-gray-500">Loading available rooms...</p>
              </div>
            )}

            {/* ========================================================
                NO ROOMS
            ======================================================== */}

            {!loading && rooms.length === 0 && (
              <div className="bg-gray-50 border border-gray-200 rounded-2xl p-10 text-center">
                <p className="text-gray-500">
                  No available rooms at the moment.
                </p>

                <button
                  type="button"
                  onClick={() =>
                    setFilters({
                      location: "",
                      budget: "",
                      roomType: "",
                    })
                  }
                  className="mt-3 text-sm text-orange-500 hover:underline"
                >
                  Clear search
                </button>
              </div>
            )}

            {/* ========================================================
                FIRST 6 ROOMS
                3 CARDS PER ROW
            ======================================================== */}

            {!loading && firstRooms.length > 0 && (
              <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5">
                {firstRooms.map((room) => (
                  <RoomCard key={room.id} room={formatRoom(room)} />
                ))}
              </div>
            )}

            {/* ========================================================
                IN-FEED ADVERTISEMENT
                1200 x 180
            ======================================================== */}

            {!loading && firstRooms.length > 0 && (
              <div className="my-8">
                <Advertisement
                  src="/images/advertisements/homePage/in-feed-banner.jepg"
                  alt="RoomVetiyo In-Feed Advertisement"
                  size="infeed"
                  href="#"
                />
              </div>
            )}

            {/* ========================================================
                MORE ROOMS
            ======================================================== */}

            {!loading && remainingRooms.length > 0 && (
              <div>
                <div className="flex items-center justify-between mb-5">
                  <div>
                    <h2 className="text-xl md:text-2xl font-bold text-gray-900">
                      More Rooms
                    </h2>

                    <p className="text-sm text-gray-500 mt-1">
                      More rooms available for you.
                    </p>
                  </div>

                  <button
                    type="button"
                    onClick={() => navigate("/search")}
                    className="text-sm font-medium text-gray-700 hover:text-orange-500"
                  >
                    View All →
                  </button>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-5">
                  {remainingRooms.map((room) => (
                    <RoomCard key={room.id} room={formatRoom(room)} />
                  ))}

                  {/* ==================================================
                        SPONSORED CARD
                    ================================================== */}

                  <SponsoredCard />
                </div>
              </div>
            )}
          </div>

          {/* ==========================================================
              RIGHT 1 PART
              ADVERTISEMENT
          ========================================================== */}

          <aside className="lg:col-span-1">
            <div className="lg:sticky lg:top-24">
              <Advertisement
                src="/images/advertisements/homePage/sidebar-ad.jpeg"
                alt="RoomVetiyo Advertisement"
                size="sidebar"
                href="#"
              />
              <Advertisement
                src="/images/advertisements/homePage/sidebar-ad.jpeg"
                alt="RoomVetiyo Advertisement"
                size="sidebar"
                href="#"
              />
            </div>
          </aside>
        </div>
      </section>

      {/* ================================================================
          FOOTER BANNER
          1200 x 150
      ================================================================ */}

      <section className="max-w-8xl mx-auto px-5 sm:px-6 mt-10">
        <Advertisement
          src="/images/advertisements/homePage/footer-banner.jpeg"
          alt="RoomVetiyo Footer Advertisement"
          size="footer"
        />
      </section>

      {/* ================================================================
          ADVERTISING BENEFITS
      ================================================================ */}

      {/* <section
        className="
        max-w-8xl
        mx-auto
        px-5
        sm:px-6
        mt-8
        mb-10
      "
      >
        <div
          className="
          border
          border-pink-200
          rounded-2xl
          overflow-hidden
        "
        >
          {/* Header *

          <div
            className="
            bg-pink-50
            py-3
            text-center
          "
          >
            <h3
              className="
              text-pink-500
              font-semibold
              text-sm
              md:text-base
            "
            >
              ADVERTISING BENEFITS
            </h3>
          </div>

          {/* Benefits *

          <div
            className="
            grid
            grid-cols-1
            sm:grid-cols-2
            lg:grid-cols-4
          "
          >
            <Benefit
              icon="◉"
              title="High Visibility"
              text="Reach thousands of room seekers daily."
            />

            <Benefit
              icon="◎"
              title="Targeted Audience"
              text="Your ads reach people actively looking for rooms."
            />

            <Benefit
              icon="↗"
              title="Brand Growth"
              text="Build awareness and grow your business."
            />

            <Benefit
              icon="₹"
              title="Affordable Plans"
              text="Flexible ad options for every business size."
            />
          </div>
        </div>
      </section> */}
    </div>
  );
}

/* ==========================================================================
   ADVERTISEMENT COMPONENT
============================================================================ */

function Advertisement({ src, alt, size = "hero", href }) {
  const sizes = {
    hero: {
      height: "h-[120px] sm:h-[135px] md:h-[150px]",
      label: "1200 × 150 px",
    },

    infeed: {
      height: "h-[100px] sm:h-[110px] md:h-[120px]",
      label: "1200 × 120 px",
    },

    footer: {
      height: "h-[80px] sm:h-[90px] md:h-[100px]",
      label: "1200 × 100 px",
    },

    sidebar: {
      height: "h-[300px] sm:h-[350px] lg:h-[400px]",
      label: "300 × 400 px",
    },
  };

  const currentSize = sizes[size] || sizes.hero;

  return (
    <div className="w-full">
      <div className="relative group">
        {/* Image */}
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="block group"
        >
          <img
            src={src}
            alt={alt}
            className={`w-full ${currentSize.height} object-cover rounded-xl border border-gray-200 group-hover:shadow-lg transition-all duration-300`}
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
          />
        </a>
      </div>

      {/* Dimensions */}

      <p className="text-center text-[9px] text-gray-400 mt-4">
        {/* {currentSize.label} */}
      </p>
    </div>
  );
}

/* ==========================================================================
   SPONSORED CARD
============================================================================ */

function SponsoredCard() {
  return (
    <div className="relative bg-gradient-to-br from-purple-50 to-purple-100 border border-purple-200 rounded-2xl overflow-hidden hover:shadow-lg transition">
      {/* Sponsored Label */}

      <div className="absolute top-3 left-3 z-10 bg-purple-600 text-white text-[9px] font-semibold px-2 py-1 rounded-full">
        SPONSORED
      </div>

      {/* Image */}
      <a
        href="#"
        target="_blank"
        rel="noopener noreferrer"
        className="block group"
      >
        <img
          src="/images/advertisements/sponsored-card.jpg"
          alt="Sponsored Advertisement"
          className="w-full h-44 object-cover "
        />
      </a>
      {/* Content */}

      <div className="p-4">
        <p className=" text-xs text-purple-600 font-semibold ">SPECIAL OFFER</p>

        <h3 className="text-lg font-bold text-gray-900 mt-1 ">
          Premium Home Furniture
        </h3>

        <p className="text-sm text-gray-600 mt-2 line-clamp-2">
          Upgrade your living space with premium furniture and modern home
          accessories.
        </p>

        <button
          type="button"
          className="mt-4 bg-purple-600 hover:bg-purple-700 text-white text-sm font-medium px-5 py-2 rounded-lg transition"
        >
          Learn More
        </button>
      </div>
    </div>
  );
}

/* ==========================================================================
   ADVERTISING BENEFIT
============================================================================ */

// function Benefit({ icon, title, text }) {
//   return (
//     <div className="p-5 flex gap-4 border-b sm:border-r lg:border-b-0 border-gray-200 last:border-r-0">
//       {/* Icon */}

//       <div className="w-10 h-10 flex-shrink-0 rounded-full bg-pink-50 text-pink-500 flex items-center justify-center text-lg font-bold ">
//         {icon}
//       </div>

//       {/* Text */}

//       <div>
//         <h4 className="font-semibold text-gray-900 text-sm">{title}</h4>

//         <p className="text-xs text-gray-500 mt-1 leading-5">{text}</p>
//       </div>
//     </div>
//   );
// }
